<template>
    <div class="container-fluid">
        <div align="left">
            <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.name" placeholder="Crafties Name"></el-input>
            <el-input class="col-lg-3 col-md-4 col-sm-5 col-5" v-model="searchForm.id" placeholder="Crafties ID"></el-input>
            <el-button @click="search()">Search</el-button>
        </div>
        <div style="margin-bottom: 6px">
            <div>
                <div style="float: left;margin-top: 6px;margin-bottom: 6px">
                    <b>{{total}}</b> Crafties
                </div>
                <div style="float: right;margin-top: 6px;margin-bottom: 6px">
                    <el-button class="el-button--small el-button--primary" @click="addIVisible=true">New ICrafties</el-button>
                    <el-button class="el-button--small el-button--primary" @click="addVisible=true">New Crafties</el-button>
                </div>
            </div>
            <el-table v-tb-height="{self:this}" ref="table" border :data="list" :height="height" empty-text="Temporarily no data">
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-image style="height:40px;" fit="scale-down" :src="scope.row.img">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline" style="font-size:40px"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="crafite_name" label="Name"></el-table-column>
                <el-table-column align="center" prop="crafite_uuid" label="ID">
                    <template slot-scope="scope">
                        {{scope.row.crafite_uuid.substring(2)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="crafite_type" label="Type">
                    <template slot-scope="scope">
                        <p v-if="scope.row.crafite_uuid.startsWith('01')">{{types[scope.row.crafite_type].label?types[scope.row.crafite_type].label:''}}</p>
                        <p v-else>{{scope.row.icrafite_type?icraftieTypes[scope.row.icrafite_type].label?icraftieTypes[scope.row.icrafite_type].label:'':''}}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="describe" label="Describe">
                    <template slot-scope="scope">
                        <p>{{scope.row.describe}}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center" min-width="150px" label="operator">
                    <template slot-scope="scope">
                        <a @click="toContent(scope.row,!scope.row.crafite_uuid.startsWith('02'))" v-if="scope.row.crafite_uuid.startsWith('01')">
                            <i v-style="{flag:scope.row.crafite_uuid.startsWith('02'),style:'color: #909399'}" class="el-icon-s-order content"></i>
                            Content
                        </a>
                        <a @click="toUpdate(scope.row,!scope.row.crafite_uuid.startsWith('02'))">
                            <i class="el-icon-s-data update"></i>
                            Update
                        </a>
                        <a @click="toDelete(scope.row.crafite_id,!scope.row.crafite_uuid.startsWith('02'))" v-if="scope.row.crafite_uuid.startsWith('01')">
                            <i v-style="{flag:scope.row.crafite_uuid.startsWith('02'),style:'color: #909399'}" class="el-icon-delete delete"></i>
                            Delete
                        </a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div align="right">
            <div class="block">
                <el-pagination
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="Update Content Trigger" :visible.sync="updateVisible" v-if="updateVisible" @close="closeUpdate('01')" destroy-on-close top="10vh" width="450px">
            <CraftiesUpdate @closeUpdate="closeUpdate('01')"></CraftiesUpdate>
        </el-dialog>
        <el-dialog title="Add Content Trigger" :visible.sync="addVisible" @close="closeAdd('01')" destroy-on-close top="10vh" width="450px">
            <CraftiesCreate @closeAdd="closeAdd('01')"></CraftiesCreate>
        </el-dialog>

        <el-dialog title="Update ICraftie" :visible.sync="updateIVisible" v-if="updateIVisible" @close="closeUpdate('02')" destroy-on-close top="10vh" width="450px">
            <ICraftiesUpdate @closeUpdate="closeUpdate('02')"></ICraftiesUpdate>
        </el-dialog>
        <el-dialog title="Add ICraftie" :visible.sync="addIVisible" @close="closeAdd('02')" destroy-on-close top="10vh" width="450px">
            <ICraftiesCreate @closeAdd="closeAdd('02')"></ICraftiesCreate>
        </el-dialog>
    </div>
</template>

<script>
    import CraftiesCreate from './CraftiesCreate'
    import CraftiesUpdate from './CraftiesUpdate'
    import ICraftiesCreate from './ICraftiesCreate'
    import ICraftiesUpdate from './ICraftiesUpdate'

    export default {
        name: 'Crafties',
        components: { 
            CraftiesCreate, CraftiesUpdate, 
            ICraftiesCreate, ICraftiesUpdate,
        },
        data () {
            return {
                list: [],
                searchForm: {
                    name: '',
                    id: ''
                },
                formData: {},
                chooseItem: null,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                addVisible: false,
                updateVisible: false,
                addIVisible: false,
                updateIVisible: false,
                height: 0,
                types: [
                    { id: 0, label: 'Craftie'},
                    { id: 1, label: 'My Crafite'},
                    { id: 2, label: "Memory Game" },
                    { id: 3, label: "AudioBook" },
                    { id: 4, label: 'Funfact'},
                    { id: 5, label: 'Trivia Cards'},
                    { id: 6, label: 'Token'},
                    { id: 7, label: 'Card Set'},
                    { id: null, label: ''},
                ],
                icraftieTypes: [
                    { id: 0, label: "" },
                    { id: 1, label: "ICraftie" },
                    { id: 2, label: "Token" },
                    { id: 3, label: "Stickers" }
                ],
            }
        },
        computed: {},
        created () {
            this.getData()
        },
        mounted () { },
        methods: {
            getData () {
                this.formData.size = this.pageSize
                this.formData.page = this.pageIndex
                this.$api.rootV1.post('/web/craftie/get', this.formData, (res) => {
                    this.list = res.data
                    this.total = res.totalCount
                })
            },
            search () {
                this.formData.crafite_name = this.searchForm.name
                this.formData.crafite_uuid = this.searchForm.id
                this.getData()
            },
            toDelete (crafite_id, flag) {
                if (flag) {
                    this.$confirm('This operation will delete the Craftie, do you want to continue?', 'prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.doDelete(crafite_id)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'cancelled!'
                        })
                    })
                }
            },
            doDelete (crafite_id) {
                let loading = this.$util.loading()
                this.$api.rootV1.post('/web/craftie/delete', {crafite_id: crafite_id}, (res) => {
                    this.$message.success('successfully deleted!')
                    this.getData()
                    loading.close()
                }, (res) => {
                    this.$message.error('failed to delete!')
                    loading.close()
                })
            },
            toUpdate (row,flag) {
                this.$util.save('craftiesUpdate', row)
                if (flag) {
                    this.updateVisible = true
                }else{
                    this.updateIVisible = true
                }
            },
            closeUpdate (type) {
                this.$util.delete('craftiesUpdate')
                if(type=='01'){
                    this.updateVisible = false
                }else{
                    this.updateIVisible = false
                }
                this.getData()
            },
            closeAdd (type) {
                if(type=='01'){
                    this.addVisible = false;
                }else{
                    this.addIVisible = false;
                }
                this.getData()
            },
            toContent (row, flag) {
                if (flag) {
                    this.$util.save('craftiesContent', row)
                    this.$router.push({name: 'craftiesContent'})
                }
            },
            handleCurrentChange (val) {
                this.pageIndex = val
                this.getData()
            },

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/crafties/Crafties.vue